let ScanConfigService = function () {
  this.scanConfig = null;

  const getScanConfig = () => {
    return this.scanConfig;
  };

  const setScanConfig = (scanConfig) => {
    this.scanConfig = scanConfig;
  };
    
  return {
      getScanConfig,
      setScanConfig
  };
};

ScanConfigService.$inject = []

export default ScanConfigService;


// WEBPACK FOOTER //
// ./client/app/services/scan-config.service.js